angular.module('rjmNg.constants')
.constant('timeRangeEnums'
  TIME_INTERVALS: [
    "None"
    "Hour"
    "Day"
    "Week"
    "Month"
    "Quarter"
    "Year"
  ]

  TIME_INTERVAL_VALUES: Object.freeze
    NONE: "None"
    HOUR: "Hour"
    DAY: "Day"
    WEEK: "Week"
    MONTH: "Month"
    QUARTER: "Quarter"
    YEAR: "Year"
    GLOBAL: "Global"

  TIME_RANGE_VALUES: Object.freeze
    START: ":first"
    END: ":null"

  TIME_INTERVAL_ICONS:
    "None": "assets/time-filter/none.svg"
    "Hour": "assets/time-filter/hour.svg"
    "Day": "assets/time-filter/day.svg"
    "Week": "assets/time-filter/week.svg"
    "Month": "assets/time-filter/month.svg"
    "Quarter": "assets/time-filter/quarter.svg"
    "Year": "assets/time-filter/year.svg"
    "Default": "assets/time-filter/default.svg"

  RANGE_TYPES: Object.freeze
    STATIC: "static"
    MOVING: "moving"

  TIME_RANGE_TYPES: Object.freeze
    STATIC: "Static"
    MOVING: "Moving"

  MOVING_TIME_RANGE_TYPES: Object.freeze
    ALL_TIME: "All-Time"
    CUSTOM: "Custom"
    TODAY: "Today"
    YESTERDAY: "Yesterday"
    THIS_WEEK: "This Week"
    THIS_MONTH: "This Month"
    THIS_QUARTER: "This Quarter"
    THIS_YEAR: "This Year"
    LAST_WEEK: "Last Week"
    LAST_MONTH: "Last Month"
    LAST_24_MONTHS: "Last 24 Months"
    LAST_QUARTER: "Last Quarter"
    LAST_YEAR: "Last Year"
    LAST_7_DAYS: "Last 7 Days"
    LAST_14_DAYS: "Last 14 Days"
    LAST_2_WEEKS: "Last 2 Weeks"
    LAST_30_DAYS: "Last 30 Days"
    LAST_90_DAYS: "Last 90 Days"
    LAST_365_DAYS: "Last 365 Days"

  MOVING_TIME_RANGE_TYPES_NAMES: Object.freeze
    ALL_TIME: "All Time"
    CUSTOM: "Custom Moving Range"
    TODAY: "Today"
    YESTERDAY: "Yesterday"
    THIS_WEEK: "This Week"
    THIS_MONTH: "This Month"
    THIS_QUARTER: "This Quarter"
    THIS_YEAR: "This Year"
    LAST_WEEK: "Last Full Week"
    LAST_MONTH: "Last Full Month"
    LAST_24_MONTHS: "Last 24 Months"
    LAST_QUARTER: "Last Full Quarter"
    LAST_YEAR: "Last Full Year"
    LAST_7_DAYS: "Last 7 Days"
    LAST_14_DAYS: "Last 14 Days"
    LAST_2_WEEKS: "Last 2 Weeks"
    LAST_30_DAYS: "Last 30 Days"
    LAST_90_DAYS: "Last 90 Days"
    LAST_365_DAYS: "Last 365 Days"

  MOVING_TIME_RANGE_UNITS: Object.freeze
    Year: "Years"
    Quarter: "Quarters"
    Month: "Months"
    Week: "Weeks"
    Day: "Days"
    Hour: "Hours"

  MOVING_TIME_RANGE_DIRECTIONS: Object.freeze
    PAST: "Ago"
    FUTURE: "From Now"
)
.constant('namedDates'
  NOW: 'Now'
  OLDEST: 'Oldest Available Date'
  NO_CHANGE: "Don't Change"
  INVALID_DATE: 'Invalid date'
)

